import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4l4trvmb: FaireBrandEntity = {
  token: "b_4l4trvmb",
  type: "brand",
  name: "Salt Sisters",
  avatarUrl:
    "https://cdn.faire.com/fastly/9cf491c74e25526918520c7834da6d2ce2ff85b508a49b49f3c8d04b3873af9e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/123bbf0172538297abc3603cdd80be7f7a32c6b941fc9122f5d51c77bc379b2f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9cf491c74e25526918520c7834da6d2ce2ff85b508a49b49f3c8d04b3873af9e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/123bbf0172538297abc3603cdd80be7f7a32c6b941fc9122f5d51c77bc379b2f.jpeg",
  location: "Goshen, IN, USA",
  minimumOrderDollars: 139,
  rating: 4.9,
  reviewCount: 245,
  isTopShop: true,
  isInsider: true,
  description:
    "At Salt Sisters, we believe the heart of every home is the kitchen. It’s where stories are shared, meals are crafted and the best memories are made. Inspired by the simple joy of gathering around the table, we create seasoning blends that make every dish feel special. From vibrant salts to handcrafted spices, our products elevate your cooking while celebrating the connection between food, family and community.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:07.934Z",
    importedBy: "entity-db-cli",
  },
};
